import request from "@/utils/request";

// 获取活动列表
export function getSignInfo(params) {
  return request({
    url: "/wechat/bizWeixinActivitySignInfo",
    method: "get",
    params
  });
}

// 活动报名接口
export function applySignInfo(data) {
  return request({
    url: "/wechat/bizWeixinActivitySignInfo",
    method: "post",
    data
  });
}

// 活动报名取消接口
export function applySignInfoCancel(data) {
  return request({
    url: "/wechat/bizWeixinActivitySignInfo/cancel",
    method: "post",
    data
  });
}

// 活动详情接口
export function getSignInfoDetail(params) {
  return request({
    url: "/wechat/bizWeixinActivitySignInfo/getWeixinActivityById",
    method: "get",
    params
  });
}
